module.exports = __webpack_public_path__ + "img/scissors.475924b7.svg";